import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const OnboardingStepNav = ({ step, completedStep }) => {
  const getStepStyle = (stepNumber) => {
    const isCurrentStep = step === stepNumber
    const isCompletedStep =
      (completedStep === 'personal_details' && stepNumber === 1) ||
      (completedStep === 'address' && stepNumber <= 2) ||
      (completedStep === 'completed' && stepNumber <= 3)

    if (isCurrentStep) {
      return 'border-hub-primary text-hub-primary opacity-100'
    } else if (isCompletedStep) {
      return 'border-green-500 bg-green-500 text-white opacity-100'
    } else {
      return 'border-gray-300 bg-gray-100 text-gray-500 opacity-50'
    }
  }

  return (
    <section className="w-full select-none flex flex-col items-center">
      <div className="flex items-center justify-center mt-2">
        <div
          className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${getStepStyle(
            1
          )}`}
        >
          {completedStep === 'personal_details' ||
          completedStep === 'address' ||
          completedStep === 'completed' ? (
            <>
              <FontAwesomeIcon icon={faCheck} />
            </>
          ) : (
            '1'
          )}
        </div>
        <div className="w-8 h-0.5 bg-gray-300 mx-2"></div>
        <div
          className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${getStepStyle(
            2
          )}`}
        >
          {completedStep === 'address' || completedStep === 'completed'
            ? '✓'
            : '2'}
        </div>
        <div className="w-8 h-0.5 bg-gray-300 mx-2"></div>
        <div
          className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${getStepStyle(
            3
          )}`}
        >
          {completedStep === 'completed' ? '✓' : '3'}
        </div>
        <div className="w-8 h-0.5 bg-gray-300 mx-2"></div>
        <div
          className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${getStepStyle(
            4
          )}`}
        >
          4
        </div>
      </div>
      <div className="flex justify-center mt-4">
        <h2 className="text-2xl font-semibold text-portal-dark-blur text-center">
          {step === 1 && 'Personal Information'}
          {step === 2 && 'Address and GP Details'}
          {step === 3 && 'Health Info'}
        </h2>
      </div>
    </section>
  )
}

export default OnboardingStepNav
